import { EnumPermission } from 'src/app/core/models/enum';
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 0,
        label: 'Dashboards',
        icon: 'bx bxs-dashboard',
        link: '/dashboard',
    },
    // {
    //     id: 0,
    //     label: 'Sample',
    //     icon: 'bx bx-layer',
    //     link: '/template/icons/boxicons',
    // },
    {
        id: 1,
        label: 'Announcement',
        icon: 'bx bxs-bell-ring',
        link: '/announcement/list',
        permission: [EnumPermission.ANNOUNCEMENT_VIEW]
    },
    {
        id: 0,
        label: 'Agent',
        isTitle: true,
        permission: [EnumPermission.AGENT_VIEW, EnumPermission.AGENT_ADD, EnumPermission.AGENT_EDIT]
    },
    {
        id: 1,
        label: 'Agent',
        icon: 'bx bx-user',
        link: '/agent/list',
        permission: [EnumPermission.AGENT_VIEW]
    },
    // {
    //     id: 1,
    //     label: 'Download Log',
    //     icon: 'bx bx-list-ul',
    //     link: '/downloadLog/list',
    //     permission: [EnumPermission.DOWNLOAD_LOG_VIEW]
    // },
    {
        id: 0,
        label: 'DCA',
        isTitle: true
    },
    {
        id: 1,
        label: 'DCA Listing Import',
        icon: 'bx bxs-file',
        link: '/taskForm/list',
        permission: [EnumPermission.TASK_FORM_VIEW]
    },
    {
        id: 1,
        label: 'Search SAN',
        icon: 'bx bx-notepad', // for task
        link: '/task/list',
        permission: [EnumPermission.TASK_VIEW]
    },
    {
        id: 1,
        label: 'Batch',
        icon: 'bx bx-food-menu', // for batch
        link: '/batch/list',
        permission: [EnumPermission.BATCH_VIEW]
    },
    {
        id: 0,
        label: 'Report',
        isTitle: true,
        permission: [EnumPermission.REPORT_DCA_VIEW, EnumPermission.REPORT_SUMMARY_BATCH_VIEW, EnumPermission.REPORT_SUMMARY_DCA_VIEW]
    },
    {
        id: 1,
        label: 'Report',
        icon: 'bx bxs-report',
        section: 'nav',
        module: 'report',
        subItems: [
            {
                id: 2,
                label: 'DCA Report',
                parentModule: 'report',
                section: 'list',
                module: 'report',
                link: '/report/dca',
                parentId: 2,
                permission: [EnumPermission.REPORT_DCA_VIEW],
            },
            {
                id: 2,
                label: 'Summary Batch Report',
                parentModule: 'report',
                section: 'list',
                module: 'report',
                link: '/report/summaryBatch',
                parentId: 2,
                permission: [EnumPermission.REPORT_SUMMARY_BATCH_VIEW],
            },
            {
                id: 2,
                label: 'Summary DCA Report',
                parentModule: 'report',
                section: 'list',
                module: 'report',
                link: '/report/summaryDca',
                parentId: 2,
                permission: [EnumPermission.REPORT_SUMMARY_DCA_VIEW],
            }
        ]
    },
    {
        id: 0,
        label: 'User Management',
        isTitle: true,
    },
    {
        id: 1,
        label: 'User',
        icon: 'bx bx-user-circle',
        link: '/admin/list',
        permission: [EnumPermission.ADMIN_VIEW]
    },
    {
        id: 1,
        label: 'User Role',
        icon: 'bx bx-toggle-right',
        link: '/authority/list',
        permission: [EnumPermission.ADMIN_AUTHORITY_VIEW]
    },
    // {
    //     id: 1,
    //     label: 'Operation Log',
    //     icon: 'bx bx-list-ul',
    //     link: '/log/list',
    //     permission: [EnumPermission.OPERATION_LOG_VIEW]
    // }
];

